import { FileText, ExternalLink } from 'lucide-react';
import { Card } from '@/components/ui/card';

// Order as provided by the client: alphabetical by division, Work Cards before Poster
const WORK_CARD_LINKS = [
  { label: 'Client Delivery And Operations Division - Work Cards', url: 'https://drive.google.com/file/d/1GrgBNe_lnxjk4b_Vy4T1Vy1jvgfphyZ3/view?usp=drivesdk' },
  { label: 'Client Delivery And Operations Division - How We Work', url: 'https://drive.google.com/file/d/1BryChXLEzGdSR2s-GSzR3Gu1iOGmv4YN/view?usp=drive_link' },
  { label: 'Design And Video Division - Work Cards', url: 'https://drive.google.com/file/d/1CW5JeJ4gfm4oU_0X9WjLb6I36qJtlTJi/view?usp=drivesdk' },
  { label: 'Design And Video Division - Poster (for ready reference of work cards)', url: 'https://drive.google.com/file/d/1tFDu2HrVJF9G5wLV_EhTZgdBNHvAbCW1/view?usp=drivesdk' },
  { label: 'Design And Video Division - How We Work', url: 'https://drive.google.com/file/d/1v_eGyzlIRmiCerOiWCe71zOsCrkJvdcs/view?usp=drive_link' },
  { label: 'Growth Systems Division - Work Cards', url: 'https://drive.google.com/file/d/1k2VegY7EF86dT1aXAxJpsp_tfJd_GLEk/view?usp=drivesdk' },
  { label: 'Growth Systems Division - Poster (for ready reference of work cards)', url: 'https://drive.google.com/file/d/1j-GtvrJHdlN0ajJTchtgz-EgFDAAkh_O/view?usp=drivesdk' },
  { label: 'Growth Systems Division - How We Work', url: 'https://drive.google.com/file/d/1aESIvnKFnWE0U0ZTpBK2i1SREdcUr-Wf/view?usp=drive_link' },
  { label: 'Paid Growth Division - Work Cards', url: 'https://drive.google.com/file/d/1k35xDcFAtyzm79VROecdyyFDyw7jI81F/view?usp=drivesdk' },
  { label: 'Paid Growth Division - Poster (for ready reference of work cards)', url: 'https://drive.google.com/file/d/1SmF-R828_TgonJ_q-vky8WTGJM73L4KR/view?usp=drivesdk' },
  { label: 'Paid Growth Division - How We Work', url: 'https://drive.google.com/file/d/18rq7XwyjllMYCYvcG7dy1_Dffjm4I2d5/view?usp=drive_link' },
  { label: 'Social And Creative Division - Work Cards', url: 'https://drive.google.com/file/d/1IBtQOxqhVySwEbBDO9XU_L35h54_eg0U/view?usp=drivesdk' },
  { label: 'Social And Creative Division - Poster (for ready reference of work cards)', url: 'https://drive.google.com/file/d/145ypjZ1p3eIP9F39QQLPT5siQr4h8Hm9/view?usp=drivesdk' },
  { label: 'Social And Creative Division - How We Work', url: 'https://drive.google.com/file/d/1nsDzNFUoqvXUQWWL09g8Kw5WMjPlhoef/view?usp=drive_link' },
  { label: 'Tech And Automation Division - Work Cards', url: 'https://drive.google.com/file/d/1USd2bFI_7td4EYtWgHpkd5TlaB1UdqwX/view?usp=drivesdk' },
  { label: 'Tech And Automation Division - How We Work', url: 'https://drive.google.com/file/d/1AbhL9Erh_SR2iMk2jb23VPvZr8xfyaXR/view?usp=drive_link' },
];

const WorkCards = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-3xl font-bold flex items-center gap-2">
        <FileText className="h-7 w-7" />
        Division Wise Work Cards (Workflows)
      </h1>
      <p className="text-muted-foreground mt-1">Click a link to open the PDF in a new tab</p>
    </div>
    <Card className="border-border/60 bg-white p-6">
      <ul className="space-y-4">
        {WORK_CARD_LINKS.map((item, idx) => (
          <li key={item.url}>
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-2 text-xl text-blue-700 hover:underline break-words"
              data-testid={`workcard-link-${idx}`}
            >
              <span>{item.label}</span>
              <ExternalLink className="h-4 w-4 shrink-0 mt-2" />
            </a>
          </li>
        ))}
      </ul>
    </Card>
  </div>
);

export default WorkCards;
